import {
  Component,
  OnInit,
  Renderer2,
  ElementRef,
  AfterViewInit,
  Output,
  EventEmitter,
  Input
} from '@angular/core';
import { PaymentProvider } from '../../models/payment-provider';
import { Observable } from 'rxjs';
import { PaymentStateService } from '../../services/payment-state.service';
import { PaymentService } from '../../services/payment.service';
import { IconDefinition } from '@fortawesome/free-brands-svg-icons';
import { IconDefinition as IconDefinitionFas } from '@fortawesome/free-solid-svg-icons';
import { OrderStateService } from '../../../order/services/order-state.service';

@Component({
  selector: 'app-payment-providers',
  templateUrl: './payment-providers.component.html',
  styleUrls: ['./payment-providers.component.css']
})
export class PaymentProvidersComponent implements OnInit {
  paymentProviders: PaymentProvider[];

  @Output() eventPayStart = new EventEmitter();

  @Input() isVuPaymentEnabled = false;

  constructor(
    private paymentStateService: PaymentStateService,
    private orderStateService: OrderStateService,
  ) {
  }

  ngOnInit(): void {
    this.paymentStateService.paymentProviders.subscribe(
      paymentProviders => {
        this.paymentProviders = paymentProviders;
        const enabledPaymentProviders = paymentProviders.filter(item => !item.disabled);
        if (enabledPaymentProviders && enabledPaymentProviders.length) {
          const sessionPaymentProviderId = this.orderStateService.sessionPaymentProviderId;
          if (sessionPaymentProviderId != null && sessionPaymentProviderId !== -1) {
            for (const paymentProvider of enabledPaymentProviders) {
              if (paymentProvider.id === sessionPaymentProviderId && !paymentProvider.disabled) {
                this.onSelectProvider(paymentProvider);
                return;
              }
            }
          }

          this.onSelectProvider(enabledPaymentProviders[0]);
        }
      });
  }

  onSelectProvider(paymentProvider: PaymentProvider): void {
    if (paymentProvider && paymentProvider.disabled) {
      return;
    }

    if (this.isVuPaymentEnabled
      && this.paymentStateService.selectedProvider
      && paymentProvider
      && this.paymentStateService.selectedProvider.id === paymentProvider.id) {
      this.eventPayStart.emit();
      return;
    }
    this.paymentStateService.selectedProvider = paymentProvider;
  }

  get selectedPaymentProvider(): PaymentProvider {
    return this.paymentStateService.selectedProvider;
  }

  isSelected(paymentProvider: PaymentProvider): boolean {
    return paymentProvider && this.selectedPaymentProvider && this.selectedPaymentProvider === paymentProvider;
  }

  getIcon(paymentProvider: PaymentProvider): IconDefinition | IconDefinitionFas {
    return this.paymentStateService.getProviderIcon(paymentProvider);
  }

  getProviderName(paymentProvider: PaymentProvider): string {
    return paymentProvider.paymentName ? paymentProvider.paymentName : paymentProvider.name;
  }

  getImageUrl(paymentProvider: PaymentProvider): string {
    if (paymentProvider == null || paymentProvider.name === null || paymentProvider.name === '') {
      return '';
    }

    const name = paymentProvider.name.toLowerCase();
    if (name === 'sofort') {
      return 'assets/svg/sofort3.svg';
    }
    if (name === 'ogone') {
      return 'assets/svg/visamastercard3.svg';
    }
    if (name === 'payone') {
      return 'assets/svg/visamastercard3.svg';
    }
    if (name === 'paypal') {
      return 'assets/svg/paypal3.svg';
    }
    if (name === 'bluecode') {
      return 'assets/svg/bluecode.svg';
    }
    if (name === 'stripe') {
      return 'assets/svg/stripe.svg';
    }

    return '';
  }

  showProviderName(paymentProvider: PaymentProvider): boolean {
    return paymentProvider.showProviderName ||
      !this.getIcon(paymentProvider) &&
      !this.getImageUrl(paymentProvider);
  }
}
